export default __webpack_public_path__ + "static/ekko-with-flame-55a8bfa76bac83775b0d6d03f4b238c0.png";